import createVoucherTravelSlice from 'store/travel'
import create from 'zustand'
import type { VoucherTravelState } from 'store/travel/type'

import createAffinitesSlice from './affinities'
import createPrivateConsignedSlice from './privateConsigned'
import createAfterSaleSlice from './afterSaleConfig'
import createAssistancesSlice from './assistances'
import createBottomSheetSlice from './bottomSheet'
import createDarkModeSlice from './darkMode'
import createDentalSlice from './dental'
import createErrorSlice from './error'
import createGadgetSlice from './gadget'
import createInsurancesSlice from './insurences'
import createLifeSlice from './life'
import createLifeticketSlice from './lifeticket'
import createLoadingSlice from './loading'
import createNavbarSlice from './navbar'
import createPageTransitionSlice from './pageTransitionAnimation'
import createQueryParamsSlice from './queryParams'
import createRouterStateSlice from './routerState'
import createUserInfoSlice from './user'
import type { AffinitiesState } from './affinities/types'
import type { PrivateConsignedState } from './privateConsigned/types'
import type { AfterSaleState } from './afterSaleConfig/types'
import type { AssistancesState } from './assistances/types'
import type { BottomSheetState } from './bottomSheet/types'
import type { DarkModeState } from './darkMode/types'
import type { DentalState } from './dental/types'
import type { ErrorState } from './error/types'
import type { GadgetState } from './gadget/types'
import type { InsuracesState } from './insurences/types'
import type { LifeState } from './life/types'
import type { LifeticketState } from './lifeticket/types'
import type { LoadingState } from './loading/types'
import type { NavbarState } from './navbar/types'
import type { PageTrasitionState } from './pageTransitionAnimation/type'
import type { QueryParamsState } from './queryParams/types'
import type { RouterState } from './routerState/type'
import type { UserInfoState } from './user/types'

type RootState = NavbarState &
  ErrorState &
  LoadingState &
  QueryParamsState &
  UserInfoState &
  BottomSheetState &
  AfterSaleState &
  PageTrasitionState &
  RouterState &
  VoucherTravelState &
  AffinitiesState &
  PrivateConsignedState &
  AssistancesState &
  DarkModeState &
  InsuracesState &
  GadgetState &
  LifeticketState &
  DentalState &
  LifeState

const useBoundState = create<RootState>()((...a) => ({
  ...createErrorSlice(...a),
  ...createLoadingSlice(...a),
  ...createNavbarSlice(...a),
  ...createQueryParamsSlice(...a),
  ...createUserInfoSlice(...a),
  ...createBottomSheetSlice(...a),
  ...createAfterSaleSlice(...a),
  ...createPageTransitionSlice(...a),
  ...createRouterStateSlice(...a),
  ...createVoucherTravelSlice(...a),
  ...createAffinitesSlice(...a),
  ...createPrivateConsignedSlice(...a),
  ...createAssistancesSlice(...a),
  ...createDarkModeSlice(...a),
  ...createInsurancesSlice(...a),
  ...createGadgetSlice(...a),
  ...createDentalSlice(...a),
  ...createLifeticketSlice(...a),
  ...createLifeSlice(...a),
}))

export default useBoundState
